var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParameterStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8020_8784)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8020_8784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8020_8784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_8020_8784)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.68586 8.814C6.76186 8.814 6.00586 9.564 6.00586 10.494C6.00586 11.418 6.76186 12.174 7.68586 12.174C8.60986 12.174 9.36586 11.418 9.36586 10.494C9.36586 9.564 8.61586 8.814 7.68586 8.814ZM7.68586 11.148C7.32586 11.148 7.03186 10.854 7.03186 10.494C7.03186 10.134 7.32586 9.84 7.68586 9.84C8.04586 9.84 8.33986 10.134 8.33986 10.494C8.34586 10.854 8.05186 11.148 7.68586 11.148ZM7.68586 8.4C8.00386 8.4 8.26186 8.142 8.26186 7.824V6.594C8.26186 6.276 8.00386 6.018 7.68586 6.018C7.36786 6.018 7.10986 6.276 7.10986 6.594V7.824C7.11586 8.142 7.37386 8.4 7.68586 8.4ZM7.68586 12.6C7.36786 12.6 7.10986 12.858 7.10986 13.176V17.424C7.10986 17.742 7.36786 18 7.68586 18C8.00386 18 8.26186 17.742 8.26186 17.424V13.176C8.26186 12.858 8.00386 12.6 7.68586 12.6ZM11.9999 10.356C11.0759 10.356 10.3199 11.106 10.3199 12.036C10.3199 12.96 11.0699 13.716 11.9999 13.716C12.9239 13.716 13.6799 12.96 13.6799 12.036C13.6799 11.112 12.9239 10.356 11.9999 10.356ZM11.9999 12.69C11.6399 12.69 11.3459 12.396 11.3459 12.036C11.3459 11.676 11.6399 11.376 11.9999 11.376C12.3599 11.376 12.6539 11.67 12.6539 12.03C12.6539 12.39 12.3599 12.69 11.9999 12.69ZM11.9999 9.918C12.3179 9.918 12.5759 9.66 12.5759 9.342V6.576C12.5759 6.258 12.3179 6 11.9999 6C11.6819 6 11.4239 6.258 11.4239 6.576V9.342C11.4239 9.66 11.6819 9.918 11.9999 9.918ZM11.9999 14.184C11.6819 14.184 11.4239 14.442 11.4239 14.76V17.412C11.4239 17.73 11.6819 17.988 11.9999 17.988C12.3179 17.988 12.5759 17.73 12.5759 17.412V14.76C12.5759 14.442 12.3179 14.184 11.9999 14.184ZM16.3139 11.82C15.3899 11.82 14.6339 12.576 14.6339 13.5C14.6339 14.424 15.3899 15.18 16.3139 15.18C17.2379 15.18 17.9939 14.43 17.9939 13.5C17.9879 12.576 17.2379 11.82 16.3139 11.82ZM16.3139 14.154C15.9539 14.154 15.6599 13.86 15.6599 13.5C15.6599 13.14 15.9539 12.846 16.3139 12.846C16.6739 12.846 16.9679 13.14 16.9679 13.5C16.9679 13.86 16.6739 14.154 16.3139 14.154ZM16.3139 11.388C16.6319 11.388 16.8899 11.13 16.8899 10.812V6.576C16.8899 6.258 16.6319 6 16.3139 6C15.9959 6 15.7379 6.258 15.7379 6.576V10.812C15.7379 11.13 15.9959 11.388 16.3139 11.388ZM16.3139 15.654C15.9959 15.654 15.7379 15.912 15.7379 16.23V17.412C15.7379 17.73 15.9959 17.988 16.3139 17.988C16.6319 17.988 16.8899 17.73 16.8899 17.412V16.23C16.8839 15.906 16.6319 15.654 16.3139 15.654Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8020_8784",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8020_8784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParameterStore);
export default __webpack_public_path__ + "static/media/Parameter-Store.d7b33a1a8f67ff1e4a6cc06b4e92c245.svg";
export { ForwardRef as ReactComponent };